
import { useState, FormEvent } from 'react';

export default function RegistrationForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [submittedName, setSubmittedName] = useState('');
  const [whatsappValue, setWhatsappValue] = useState('');
  const [idadeValue, setIdadeValue] = useState('');

  const handleIdadeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const raw = e.target.value.replace(/\D/g, '').slice(0, 2);
    setIdadeValue(raw);
  };

  const formatWhatsapp = (value: string) => {
    const digits = value.replace(/\D/g, '').slice(0, 11);
    if (digits.length <= 2) return digits;
    if (digits.length <= 7) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  };

  const handleWhatsappChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setWhatsappValue(formatWhatsapp(e.target.value));
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    const form = e.currentTarget;
    const formData = new FormData(form);

    const nome = formData.get('nome') as string;
    const idade = idadeValue;
    const whatsapp = whatsappValue.replace(/\D/g, '');
    const cidade = formData.get('cidade') as string;

    if (!nome || !idade || whatsapp.length < 10 || !cidade) {
      setSubmitStatus('error');
      setIsSubmitting(false);
      return;
    }

    const payload = new URLSearchParams();
    payload.append('nome', nome);
    payload.append('idade', idade);
    payload.append('whatsapp', whatsappValue);
    payload.append('cidade', cidade);

    try {
      const response = await fetch('https://readdy.ai/api/form/d6irckhboei3uoqmppdg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: payload.toString(),
      });

      if (response.ok) {
        setSubmittedName(nome);
        setSubmitStatus('success');
        form.reset();
        setWhatsappValue('');
        setIdadeValue('');

        if (typeof window !== 'undefined' && (window as any).fbq) {
          (window as any).fbq('track', 'Lead');
        }
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleShareWhatsApp = () => {
    const text = encodeURIComponent(
      `🌟 Me inscrevi na Seletiva Presencial da Four Models em Barra do Bugres - MT!\n\n📅 Data: 11/03 • Quarta-feira\n⏰ Horário: 19h30\n📍 Local: Atlas Hotel\n\nVem participar também! Inscrição 100% gratuita 👇\n${window.location.href}`
    );
    window.open(`https://wa.me/?text=${text}`, '_blank');
  };

  const handleNewRegistration = () => {
    setSubmitStatus('idle');
    setSubmittedName('');
  };

  if (submitStatus === 'success') {
    return (
      <section id="inscricao" className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-10">
            <h4 className="text-3xl sm:text-4xl md:text-5xl font-black text-black mb-3 px-4">
              <a href="#inscricao">
                Garanta sua{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">
                  vaga gratuita
                </span>
              </a>
            </h4>
            <p className="text-sm sm:text-base text-gray-500">Leva menos de 30 segundos para se inscrever.</p>
          </div>

          <div className="bg-white rounded-2xl shadow-2xl p-7 sm:p-10 border-2 border-yellow-400 text-center">
            <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-600 rounded-full flex items-center justify-center mx-auto mb-5">
              <i className="ri-check-line text-black text-3xl font-bold"></i>
            </div>

            <h2 className="text-2xl sm:text-3xl font-black text-black mb-2">
              Inscrição Confirmada!
            </h2>
            {submittedName && (
              <p className="text-gray-500 text-sm sm:text-base mb-1">
                Parabéns, <strong>{submittedName}</strong>! 🎉
              </p>
            )}
            <p className="text-gray-500 text-sm sm:text-base mb-6">
              Entraremos em contato pelo WhatsApp com os detalhes.
            </p>

            <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-5 text-left mb-6">
              <p className="font-black text-black text-sm sm:text-base mb-3 flex items-center gap-2">
                <span>📍</span> Nos vemos em Barra do Bugres - MT!
              </p>
              <div className="space-y-1.5 text-sm text-gray-700">
                <p><strong>Data:</strong> 11/03 • Quarta-feira</p>
                <p><strong>Horário:</strong> 19h30</p>
                <p><strong>Local:</strong> <span className="text-yellow-600 font-semibold">Atlas Hotel</span></p>
              </div>
            </div>

            <p className="text-gray-500 text-sm mb-3">
              Chame seus amigos para participar também! 🎉
            </p>

            <button
              onClick={handleShareWhatsApp}
              className="w-full bg-green-500 hover:bg-green-600 text-white px-6 py-4 rounded-full text-sm sm:text-base font-black transition-all duration-300 shadow-lg hover:shadow-xl flex items-center justify-center gap-3 cursor-pointer whitespace-nowrap mb-4"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Compartilhar no WhatsApp
            </button>

            <button
              onClick={handleNewRegistration}
              className="text-yellow-600 hover:text-yellow-700 text-sm font-semibold underline cursor-pointer transition-colors"
            >
              Fazer nova inscrição
            </button>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section id="inscricao" className="py-16 sm:py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-10">
          <h4 className="text-3xl sm:text-4xl md:text-5xl font-black text-black mb-3 px-4">
            <a href="#inscricao">
              Garanta sua{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-yellow-600">
                vaga gratuita
              </span>
            </a>
          </h4>
          <p className="text-sm sm:text-base text-gray-500">Leva menos de 30 segundos para se inscrever.</p>
        </div>

        <form
          id="form-inscricao"
          data-readdy-form
          onSubmit={handleSubmit}
          className="bg-white rounded-2xl shadow-2xl p-7 sm:p-10 border-2 border-gray-100"
        >
          <div className="space-y-5 sm:space-y-6">
            <div>
              <label htmlFor="nome" className="block text-sm font-bold text-gray-700 mb-2">
                Nome Completo <span className="text-red-500">*</span>
              </label>
              <input
                id="nome"
                name="nome"
                required
                className="w-full px-4 py-3.5 border-2 rounded-xl focus:outline-none transition-colors text-sm text-gray-900 border-gray-200 focus:border-yellow-500 placeholder-gray-400"
                placeholder="Seu nome completo"
              />
            </div>

            <div>
              <label htmlFor="idade" className="block text-sm font-bold text-gray-700 mb-2">
                Idade <span className="text-red-500">*</span>
              </label>
              <input
                id="idade"
                name="idade"
                required
                type="text"
                inputMode="numeric"
                value={idadeValue}
                onChange={handleIdadeChange}
                maxLength={2}
                className="w-full px-4 py-3.5 border-2 rounded-xl focus:outline-none transition-colors text-sm text-gray-900 border-gray-200 focus:border-yellow-500 placeholder-gray-400"
                placeholder="Sua idade (entre 3 a 35 anos)"
              />
            </div>

            <div>
              <label htmlFor="whatsapp" className="block text-sm font-bold text-gray-700 mb-2">
                WhatsApp <span className="text-red-500">*</span>
              </label>
              <input
                id="whatsapp"
                name="whatsapp"
                required
                type="tel"
                value={whatsappValue}
                onChange={handleWhatsappChange}
                className="w-full px-4 py-3.5 border-2 rounded-xl focus:outline-none transition-colors text-sm text-gray-900 border-gray-200 focus:border-yellow-500 placeholder-gray-400"
                placeholder="(51) 98129-9804"
              />
            </div>

            <div>
              <label htmlFor="cidade" className="block text-sm font-bold text-gray-700 mb-2">
                Cidade <span className="text-red-500">*</span>
              </label>
              <input
                id="cidade"
                name="cidade"
                required
                className="w-full px-4 py-3.5 border-2 rounded-xl focus:outline-none transition-colors text-sm text-gray-900 border-gray-200 focus:border-yellow-500 placeholder-gray-400"
                placeholder="Ex: Barra do Bugres - MT"
              />
            </div>
          </div>

          {submitStatus === 'error' && (
            <div className="mt-6 p-4 bg-red-50 border border-red-200 rounded-xl">
              <p className="text-red-800 text-sm font-semibold text-center">
                ✗ Erro ao enviar inscrição. Por favor, tente novamente.
              </p>
            </div>
          )}

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full mt-8 bg-gradient-to-r from-yellow-500 to-yellow-600 text-black px-6 py-4 sm:py-5 rounded-full text-sm sm:text-base font-black hover:from-yellow-400 hover:to-yellow-500 transition-all duration-300 shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap tracking-wide flex items-center justify-center text-center"
          >
            {isSubmitting ? 'ENVIANDO...' : 'GARANTIR MINHA VAGA GRATUITA'}
          </button>

          <p className="text-center text-xs text-gray-400 mt-4">
            Inscrição 100% gratuita • Seus dados estão seguros
          </p>
        </form>
      </div>
    </section>
  );
}
